const priority = {
  HIGH: 'high',
  NORMAL: 'normal',
  LOW: 'low',
  LOWEST: 'lowest'
};

module.exports = priority;
